<template lang="pug">
  b-container(fluid)
    b-row(v-if="lambdas.length")
      b-col(md="6", v-for="lambda in lambdas", :key="lambda.lambda_id")
        p.text-help.mb-0 {{lambda.name}}
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const lambdaController = createNamespacedHelpers('lambda')

export default {
  computed: {
    ...lambdaController.mapState({
      lambdas: state => state.lambdas
    }),
  },
  methods: {
    ...mapActions(['lambda/all', 'lambda/create', 'lambda/destroy']),
    getLambdas () {
      let self = this
      // this.showLoadingScreen()

      this['lambda/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {

          }
        }
      })
    },
    createLambda () {
      var self = this
      let json_data = {
        isSimple: this.isSimple && this.isEditable,
        name: 'Nueva Extensión',
        description: '',
        runtime: '0',
        account_id: self.$route.params.account_id,
      };

      if(this.isSimple && this.isEditable) {
        json_data.code = me.editor.getValue();
      } else {
        if(this.fileName == '')
          return this.notify('Debes subir el comprimido de tu proyecto.', 'warning');
        json_data.fileName = me.fileName;
        if(this.handler == '')
          return this.notify('Especifica el nombre del archivo que contine la función handler.', 'warning');
        json_data.handler = me.handler;
      }

      this['lambda/create']({
        ...json_data,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            
          }
        }
      })
    },
    deleteLambda (row) {
      var self = this
      this['lambda/destroy']({
        ...row,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {

          }
        }
      })
    },
  },
  mounted () {
    this.getLambdas()
  }
}
</script>

<style lang="scss" scoped>
</style>
